module.exports = __webpack_public_path__ + "static/media/jaguarLandRover.264f95a4.gif";